import {Injectable} from '@angular/core'
import {QueueingSubject} from 'queueing-subject'
import {Observable} from 'rxjs/Observable'
import {WebSocketService} from 'angular2-websocket-service'
import {UserService} from './user.service';
import {AppSettings} from '../models/AppSettings';

@Injectable()
export class ServerSocket {
    private inputStream: QueueingSubject<any>
    public outputStream: Observable<any>

    constructor(private socketFactory: WebSocketService, private user: UserService) {}

    public connect() {
        if (this.outputStream)
            return this.outputStream
            if(this.user.getProfilo()==null){
                return;
            }
        return this.outputStream = this.socketFactory.connect(
            AppSettings.WS_ENDPOINT+"" + this.user.getProfilo()['sessionUID'],
            this.inputStream = new QueueingSubject<any>()
        ).share()
    }

    public send(message: any): void {
        this.inputStream.next(message)
    }
}


// WEBPACK FOOTER //
// ./src/app/service/server-socket.service.ts